export default {
  common: {
    edited: 'Modifié',
    error: {
      general: 'Oups !',
      failedToOpenMaps: "Impossible d'ouvrir la carte",
      failedToOpenLink:
        "Impossible d'ouvrir le lien. Aucun navigateur web n'est disponible sur cet appareil.",
      reportTooMany: 'Tu as envoyé beaucoup de signalements récemment. Attends un peu et réessaie.',
      reportFailed: "Impossible d'ouvrir le formulaire de signalement. Réessaie.",
      reportUnavailable: "Ce contenu n'est plus disponible pour un signalement.",
      popupBlocked:
        "Ton navigateur a bloqué l'ouverture du formulaire. Autorise les fenêtres pop-up pour ce site et réessaie.",
      ipBlocked:
        "Ton adresse IP a été bloquée en raison d'une activité suspecte. Si tu penses qu'il s'agit d'une erreur, contacte le support.",
      crashTitle: "Oups ! Quelque chose s'est mal passé",
      crashSubtitle: 'Nous avons été informés et nous étudions le problème.',
      crashReload: 'Recharger',
      crashRetry: 'Réessayer',
    },
    updateBanner: {
      message: 'Nous avons apporté des améliorations',
      refresh: 'Recharger',
    },
    connection: {
      offline: 'Pas de connexion internet',
      connecting: 'Connexion en cours...',
    },
    success: 'Succès !',
    follow: 'Suivre',
    unfollow: 'Ne plus suivre',
    followed: 'Suivi',
    message: 'Message',
    empty: 'Rien à voir ici pour le moment',
    post: 'publication',
    comment: 'commentaire',
    photo: 'photo',
    month: 'mois',
    year: 'année',
    cancel: 'Annuler',
    continue: 'Continuer',
    back: 'Retour',
    delete: 'Supprimer',
    update: 'Mettre à jour',
    saveChanges: 'Enregistrer',
    scrollToTop: 'Remonter en haut',
    undo: 'Annuler',
    report: 'Signaler',
    openingForm: 'Ouverture du formulaire...',
    accept: 'Accepter',
    reject: 'Refuser',
    retry: 'Réessayer',
    send: 'Envoyer',
    unblock: 'Débloquer',
    comingSoon: 'Bientôt disponible',
    loading: 'Chargement...',
    done: 'Valider',
    clear: 'Effacer',
    clearAll: 'Réinitialiser',
    search: 'Rechercher...',
    share: {
      success: 'Partagé avec succès',
      error: 'Échec du partage',
      copied: 'Lien copié dans le presse-papiers',
      shareLink: 'Partager le lien',
      url: 'URL',
      copy: 'Copier',
      open: 'Ouvrir',
    },
    validation: {
      min: 'Doit contenir au moins {{minLength}} caractères',
      max: 'Doit contenir au plus {{maxLength}} caractères',
      required: 'Ce champ est requis',
      requiredField: '{{field}} est requis',
    },
    filters: {
      myType: 'mon type',
      all: 'filtres',
    },
    relativeTime: {
      now: "à l'instant",
      justNow: "à l'instant",
    },
  },
  myTypeFilter: {
    title: 'Filtre Mon Type',
    enableOption: 'Activer',
    disableOption: 'Désactiver',
    statusEnabled: 'Actif',
    statusDisabled: 'Inactif',
    configure: 'Configurer…',
    configureTitle: 'Configurer le Filtre Mon Type',
    enabled: 'Filtre Mon Type activé',
    disabled: 'Filtre Mon Type désactivé',
    enableError: "Échec de l'activation du filtre",
    disableError: 'Échec de la désactivation du filtre',
    infoTitle: "Qu'est-ce que le Filtre Mon Type ?",
    infoDescription:
      'Définis tes préférences une fois et les listes de publications, membres et photos afficheront automatiquement uniquement les personnes correspondant à tes critères. Tu peux activer ou désactiver ce filtre à tout moment.',
    preview: 'Aperçu',
    apply: 'Appliquer',
    appliedSuccess: 'Paramètres du filtre enregistrés',
    appliedError: "Échec de l'enregistrement des paramètres du filtre",
    filteredOutPercent: '{{percent}}% des membres filtrés',
    filterWarning: 'Filtrer trop de personnes peut impacter ton expérience.',
  },
  sensitiveContent: {
    title: 'Contenu sensible',
    statusHidden: 'Masqué',
    statusVisible: 'Visible',
    configure: 'Configurer...',
  },
  navigation: {
    feeds: 'Fils',
    people: 'Membres',
    photo: 'Photo',
    photos: 'Photos',
    events: 'Événements',
    discover: 'Découvrir',
  },
  communities: {
    myCommunities: 'Mes communautés',
    menu: {
      remove: 'Retirer de Mes communautés',
    },
    delete: {
      confirmTitle: 'Retirer la communauté',
      confirmMessage:
        'Veux-tu vraiment retirer {{communityName}} de Mes communautés ? Tu pourras te reconnecter plus tard.',
      success: 'Communauté retirée',
      error: 'Échec du retrait de la communauté',
    },
    visitSite: 'Visiter {{communityName}}',
  },
  auth: {
    createAccount: 'Créer un compte',
    signIn: {
      title: 'Se connecter',
      welcomeBack: 'Bon retour !',
      heading: 'Connecte-toi à {{communityName}}',
      usernameLabel: "Nom d'utilisateur",
      usernamePlaceholder: "Entrez le nom d'utilisateur",
      usernameNotFound: "Nom d'utilisateur introuvable",
      passwordLabel: 'Mot de passe',
      passwordPlaceholder: 'Entrez le mot de passe',
      passwordIncorrect: "Mot de passe ou nom d'utilisateur incorrect",
      rememberMe: 'Se souvenir de moi',
      forgotPassword: 'Mot de passe oublié ?',
      submit: 'Se connecter',
      submitting: 'Connexion...',
      noAccount: "Tu n'as pas de compte ?",
      signUp: "S'inscrire",
      loginFailedToast: 'Échec de la connexion',
      removeCredentialsError: 'Échec de la suppression des identifiants',
      unexpectedError: 'Une erreur inattendue est survenue',
    },
    signUp: {
      redirectHelper:
        'Tu seras redirigé vers notre ancien site {{communityName}} pour créer un compte. Une fois ton compte créé, tu pourras revenir dans cette application pour te connecter.',
      successToast: "Compte créé. Nous t'avons envoyé ton mot de passe par e‑mail.",
    },
    forgotPassword: {
      title: 'Mot de passe oublié',
      redirectHelper:
        "Tu seras redirigé vers notre ancien site {{communityName}} pour réinitialiser ton mot de passe. Après avoir reçu ton nouveau mot de passe par e-mail, reviens dans l'app pour te connecter.",
      successToast: "Nous t'avons envoyé un nouveau mot de passe par e‑mail.",
    },
  },
  feeds: {
    global: 'Fil global',
    global_short: 'Global',
    local: 'Fil local',
    local_short: 'Local',
    network: "Fil d'abonnements",
    network_short: 'Abonnements',
    search: 'Recherche',
    search_short: 'Recherche',
    search_placeholder: 'Recherche dans les publications',
    empty: 'Désolé, aucun résultat trouvé',
    latestSearches: 'Recherches récentes',
    popularSearches: 'Recherches populaires',
    popularHashtags: 'Hashtags populaires',
    onlineMembers: 'En ligne',
    profileVisitors: 'Ont visité mon profil',
    searchMembersHint: "Tu cherches quelqu'un ?",
    searchMembersLink: 'Rechercher des membres',
    pinned: 'Défini comme fil par défaut',
    unpinned: 'Fil global restauré par défaut',
    alreadyDefault: "C'est déjà ton fil par défaut. Change de fil pour le modifier.",
    radius: {
      title: 'Rayon',
      km: 'km',
      mi: 'mi',
    },
  },
  messages: {
    title: 'Messages',
    inbox: 'Boîte de réception',
    inboxBadgeUnreadCaption_one: 'non lu',
    inboxBadgeUnreadCaption_other: 'non lus',
    inboxBadgeMessagesCaption_one: 'message',
    inboxBadgeMessagesCaption_other: 'messages',
    unread: 'Non lus',
    online: 'En ligne',
    deleted: 'Supprimés',
    emptyDeleted: 'Aucune conversation supprimée dans les 90 derniers jours',
    search: 'Rechercher',
    search_placeholder: "Entrez un nom d'utilisateur",
    empty: 'Aucun message à afficher',
    conversation: 'Conversation',
    emptyConversation: 'Aucun élément de conversation à afficher',
    typeMessage: 'Écrire un message...',
    photoMessage: 'a envoyé une photo',
    gifMessage: 'a envoyé un GIF',
    youSentPhoto: 'Tu as envoyé une photo',
    youSentGif: 'Tu as envoyé un GIF',
    youSentSticker: 'Tu as envoyé un sticker',
    youSentClip: 'Tu as envoyé un clip',
    stickerMessage: 'a envoyé un sticker',
    clipMessage: 'a envoyé un clip',
    replyFailed: "Échec de l'envoi de la réponse",
    compose: {
      messageToUser: 'Message à {{userName}}',
      enterMessage: 'Écris ton message...',
    },
    errors: {
      failedToLoad: 'Échec du chargement de la conversation',
      failedToSend: "Échec de l'envoi du message",
    },
    success: {
      messageSent: 'Message envoyé avec succès',
    },
    loadOlderMessages: 'Charger les anciens messages',
    loadingOlderMessages: 'Chargement des anciens messages...',
    loadingNewerMessages: 'Chargement des nouveaux messages...',
    markAsRead: {
      error: 'Échec du marquage du message comme lu',
    },
    markAsUnread: {
      error: 'Échec du marquage du message comme non lu',
    },
    delete: {
      success: 'Message supprimé avec succès',
      error: 'Échec de la suppression du message',
    },
    undelete: {
      success: 'Message restauré avec succès',
      error: 'Échec de la restauration du message',
    },
    menu: {
      markRead: 'Marquer comme lu',
      markUnread: 'Marquer comme non lu',
      viewProfile: 'Voir le profil',
      deleteConversation: 'Supprimer la conversation',
      restoreConversation: 'Restaurer la conversation',
      reportConversation: 'Signaler la conversation',
    },
    copy: {
      success: 'Contenu copié dans le presse-papiers',
      error: 'Échec de la copie du contenu',
      noContent: 'Aucun contenu à copier',
    },
    download: {
      label: 'Enregistrer la photo',
      success: 'Photo enregistrée dans ta photothèque',
      error: "Impossible d'enregistrer la photo",
      permissionDenied:
        "L'autorisation d'accès à la photothèque est requise pour enregistrer des photos",
    },
    unreadMessage: 'Message non lu',
    uploadPhoto: "Télécharger l'image",
    dropImageToSend: "Déposez l'image pour envoyer",
    dropImageToSendToUser: "Déposez l'image pour envoyer à {{userName}}",
    sendPhoto: 'Envoyer la photo',
    photoUploadFailed: "Échec du téléchargement de l'image",
    photoUploadSuccess: 'Image téléchargée avec succès',
    selectPhoto: 'Photos',
    takePhoto: 'Caméra',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    cameraPermissionNotGranted: 'Permission de caméra non accordée',
    mediaLibraryPermissionNotGranted: 'Permission de bibliothèque multimédia non accordée',
    failedToPickImage: "Échec de la sélection de l'image",
    imageTooLarge: "L'image est trop volumineuse. La taille maximale est de {{size}}MB.",
    adminClosedInfo:
      "Cette conversation est fermée. Pour tout suivi, ouvrez un ticket d'assistance et incluez les détails pertinents.",
    contactSupport: "Contacter l'assistance",
    newAccountNotice: {
      title: '{{name}} a créé son compte récemment',
      body: 'Prends le temps de faire connaissance avec les nouveaux membres. Fais attention aux infos personnelles que tu partages, et méfie-toi si on te demande de continuer la discussion sur Telegram, WhatsApp, par SMS ou sur tout autre service de messagerie.',
    },
  },
  people: {
    nearby: 'Membres à proximité',
    nearby_short: 'À proximité',
    online: 'Membres en ligne',
    online_short: 'En ligne',
    birthdays: 'Anniversaires',
    birthdays_short: 'Anniversaires',
    new: 'Nouveaux membres',
    new_short: 'Nouveaux',
    following: 'Membres que je suis',
    following_short: 'Abonnements',
    followers: 'Mes abonnés',
    followers_short: 'Abonnés',
    visitors: 'Mes visiteurs',
    visitors_short: 'Visiteurs',
    search: 'Recherche de membres',
    search_short: 'Recherche',
    empty: 'Désolé, cela est vide',
    displayModeCompact: 'Vue compacte',
    displayModeRegular: 'Vue normale',
    nearbyFilter: {
      online: 'En ligne',
      recent: 'Récents',
      active: '90 derniers jours',
      newmembers: 'Nouveaux',
      all: 'Tous',
    },
  },
  search: {
    username: "Nom d'utilisateur",
    usernamePlaceholder: "Rechercher par nom d'utilisateur",
    location: 'Localisation',
    nearMe: 'Près de moi',
    anywhere: "N'importe où",
    customLocation: 'Emplacement personnalisé',
    ranges: 'Plages',
    age: 'Âge',
    bmi: 'IMC',
    filters: 'Filtres',
    additional: 'Filtres supplémentaires',
    hasPhotos: 'A des photos',
    hasPrivatePhotos: 'A des photos privées',
    isOnline: 'Actuellement en ligne',
    isActive: 'Actif au cours des 90 derniers jours',
    isNew: 'Nouveau membre',
    isFollower: 'Me suit',
    imFollowing: 'Suivis',
    imTheirBodyType: "S'intéresse à mon type de corps",
    clearAll: 'Réinitialiser',
    search: 'Rechercher',
    anything: 'Peu importe',
    to: 'à',
    andUnder: 'et moins',
    andAbove: 'et plus',
    multipleSelected: '{{count}} sélectionnés',
    selectedCount: '{{count}} sélectionnés',
    noneSelected: 'Aucun sélectionné',
    selectAtLeastOneFilter: 'Sélectionne au moins un filtre pour lancer ta recherche',
    restoredFiltersTitle: 'Filtres restaurés',
    restoredFiltersDescription:
      'Les filtres de ta dernière recherche ont été restaurés. Tu veux repartir de zéro ? Clique sur le bouton réinitialiser ci-dessous.',
  },
  discover: {
    seeMore: 'Voir plus',
    tabBarHintLead: 'Tes onglets ont un menu secret',
    tabBarHintBody:
      'Appuie longuement, fais glisser, et accède à n\'importe quelle liste en un geste.',
    sectionSubtitles: {
      photos: {
        latest: 'Photos publiques de la communauté',
        network: 'Photos publiques des membres que tu suis',
        private: 'Photos privées des membres qui t\'y autorisent',
        favorites: 'Photos que tu as aimées',
      },
      events: {
        upcoming: 'Tous les événements à venir de la communauté',
        nearby: 'Événements à venir dans un rayon de {{distance}}',
        network: 'Événements auxquels participent les membres que tu suis',
        past: 'Événements passés archivés de la communauté',
      },
    },
  },
  photos: {
    photoOf: 'Photo de {{userName}}',
    posted: 'Publié',
    latest: 'Dernières photos (Tout le monde)',
    latest_short: 'Récentes',
    network: 'Dernières photos (Abonnements)',
    network_short: 'Abonnements',
    private: 'Dernières photos (Privées)',
    private_short: 'Privées',
    favorites: 'Photos favorites',
    favorites_short: 'Favoris',
    addPublicPhoto: 'Ajouter une photo publique',
    addPrivatePhoto: 'Ajouter une photo privée',
    dropToUploadPublic: 'Déposez pour envoyer vers Public',
    dropToUploadPrivate: 'Déposez pour envoyer vers Privé',
    captionPlaceholder: 'Ajouter une légende (facultatif)',
    uploadSuccess: 'Photo téléchargée',
    uploadFailed: 'Échec du téléchargement de la photo',
    uploadingImage: "Téléchargement de l'image...",
    policyLink: 'Lis notre politique photo',
    artworkNotice:
      'Les images générées par IA doivent être identifiées comme telles et publiées avec modération.',
    artworkNoticeFerzu:
      'Les œuvres d\u2019art doivent être créditées. Les images générées par IA ne sont pas autorisées.',
    empty: 'Aucune photo à afficher',
    sensitiveReminder: {
      title: 'Les photos sensibles et non révisées sont masquées',
      body: 'Tes paramètres de sécurité masquent les photos sensibles et non révisées. Tu peux modifier cette préférence à tout moment dans les filtres ou les paramètres.',
      action: 'Voir les options de sécurité',
      dismiss: 'Ignorer',
    },
  },
  photo: {
    menu: {
      editCaption: 'Modifier la légende',
      useAsProfilePhoto: 'Utiliser comme photo de profil',
      moveToPrivate: 'Déplacer vers le dossier privé',
      requestReview: 'Demander une révision',
      report: 'Signaler la photo',
      delete: 'Supprimer la photo',
    },
    caption: {
      placeholder: 'Ajouter une légende (facultatif)',
      updateSuccess: 'Légende mise à jour',
      updateError: 'Échec de la mise à jour de la légende',
    },
    profile: {
      confirmTitle: 'Utiliser comme photo de profil',
      confirmMessage: 'Veux-tu vraiment utiliser cette photo comme photo de profil ?',
      setSuccess: 'Photo de profil mise à jour',
      setError: 'Échec de la mise à jour de la photo de profil',
    },
    private: {
      success: 'Photo déplacée vers le dossier privé',
      error: 'Échec du déplacement de la photo vers le dossier privé',
    },
    locked: {
      message:
        'Passez à {{premiumPlan}} pour voir des photos illimitées dans les listes et en plein écran.',
    },
    review: {
      requestSuccess: 'Révision demandée',
      requestError: 'Échec de la demande de révision',
      dialogTitle: 'Évaluation de la photo',
      dialogIntro:
        "Si tu penses que notre système d'évaluation basé sur l'IA ou des réviseurs humains ont fait une erreur en déterminant l'évaluation de ta photo, ou si tu souhaites déplacer une photo de ton dossier Privé vers Public, tu peux demander une révision manuelle pour que la photo soit réévaluée. Note que chaque photo ne peut être révisée qu'une seule fois et que le processus peut prendre quelques heures.",
      possibleRatingsTitle: 'Les évaluations possibles sont :',
    },
    delete: {
      confirmTitle: 'Supprimer la photo',
      confirmMessage: 'Es-tu sûr de vouloir supprimer cette photo ? Cette action est irréversible.',
      success: 'Photo supprimée avec succès',
      error: 'Échec de la suppression de la photo',
    },
  },
  events: {
    upcoming: 'Événements à venir',
    upcoming_short: 'À venir',
    nearby: 'Événements à proximité',
    nearby_short: 'Proximité',
    network: 'Événements du réseau',
    network_short: 'Réseau',
    attending: 'Participant',
    attend: 'Participer',
    unattend: 'Ne plus participer',
    follow: 'Suivre',
    following: 'Suivi',
    attendees: 'participants',
    attendees_one: 'participant',
    attendees_other: 'participants',
    attendees_short: 'Participants',
    followers: 'abonnés',
    followers_one: 'abonné',
    followers_other: 'abonnés',
    followers_short: 'Abonnés',
    past: 'Événements passés',
    past_short: 'Passés',
    organizer: 'Organisateur',
    curator: 'Curateur',
    curatorNotice:
      "Cette personne contribue à maintenir les annonces d'événements. Signale toute inexactitude. Si tu es l'organisateur de l'événement, tu peux reprendre cette page en contactant {{communityName}}.",
    date_time: 'Date et heure',
    location: 'Lieu',
    website: 'Site web',
    empty: 'Aucun événement à afficher',
    noEventsForMember: 'Aucun événement pour le moment',
    attendeesCount_one: '{{count}} participant',
    attendeesCount_other: '{{count}} participants',
    attendSuccess: 'Tu participes à cet événement',
    unattendSuccess: 'Tu ne participes plus à cet événement',
    attendError: 'Impossible de confirmer la participation',
    unattendError: "Impossible d'annuler la participation",
    followError: "Impossible de suivre l'événement",
    unfollowError: "Impossible de ne plus suivre l'événement",
    createSuccess: 'Événement créé',
    updateSuccess: 'Événement mis à jour',
    createError: "Impossible de créer l'événement",
    updateError: "Impossible de mettre à jour l'événement",
    deleteSuccess: 'Événement supprimé',
    deleteError: "Impossible de supprimer l'événement",
    deleteEvent: "Supprimer l'événement",
    deleteConfirmTitle: "Supprimer l'événement ?",
    deleteConfirmMessage:
      'Es-tu sûr de vouloir supprimer cet événement ? Cette action est irréversible.',
    createEvent: 'Nouvel événement',
    editEvent: "Modifier l'événement",
    form: {
      code: "Code de l'événement",
      codePlaceholder: 'ex. mon-evenement-2026',
      codeHint: 'Lettres, chiffres, tirets et underscores. Ne peut pas commencer par un chiffre.',
      name: "Nom de l'événement",
      namePlaceholder: "Entrer le nom de l'événement",
      nameHint:
        "Évite d'inclure la date ou le mois dans le nom de l'événement. Si nécessaire, ajoute-les à la fin du nom.",
      startDate: 'Date de début',
      endDate: 'Date de fin (optionnel)',
      selectDate: 'Sélectionner une date',
      startTime: 'Heure de début',
      endTime: 'Heure de fin',
      selectTime: "Définir l'heure",
      timesError: 'Définis les deux heures ou aucune',
      location: 'Lieu',
      selectLocation: 'Sélectionner un lieu',
      venue: 'Lieu, salle ou hôtel',
      venuePlaceholder: 'ex. Centre de congrès',
      website: 'Site web',
      websitePlaceholder: 'https://votresiteweb.com',
      websiteError: "L'URL du site web doit commencer par https://",
      details: "Détails de l'événement",
      detailsPlaceholder: "Décris l'événement...",
      organizer: "Je suis l'organisateur de cet événement",
      save: 'Enregistrer',
      create: "Créer l'événement",
      required: 'Obligatoire',
    },
    addToCalendar: 'Ajouter au calendrier',
    share: {
      title: 'Découvre cet événement',
      message: 'Découvre {{eventName}}',
      shareEvent: "Partager l'événement",
    },
  },
  post: {
    like_one: "{{count}} j'aime",
    like_other: "{{count}} j'aimes",
    comment_one: '{{count}} commentaire',
    comment_other: '{{count}} commentaires',
    addComment: 'Commenter',
    announcement: 'Annonce',
    singlePost: 'Publication',
    newPost: 'Nouvelle publication',
    placeholder: 'À quoi penses-tu ?',
    compose: {
      wallPlaceholder: 'Écrire sur le mur de {{userName}}...',
    },
    publish: 'Publier',
    createSuccess: 'Ta publication a été publiée',
    createError: 'Échec de la publication',
    editSuccess: 'Ta publication a été mise à jour',
    editError: 'Échec de la mise à jour de la publication',
    readMore: 'Lire la suite',
    featuredPhoto: {
      warningWithReset:
        'Il semble que tu aies publié une autre photo très récemment, ce qui signifie que cette photo ne sera pas mise en avant dans le fil global, à moins que tu attendes {{minutes}} minutes pour la publier',
    },
    menu: {
      edit: 'Modifier la publication',
      dismissAnnouncement: "Masquer l'annonce",
      share: 'Partager la publication',
      stopNotifications: 'Désactiver les notifications',
      resumeNotifications: 'Reprendre les notifications',
      report: 'Signaler la publication',
      delete: 'Supprimer la publication',
    },
    mute: {
      title: 'Désactiver les notifications pour combien de temps?',
      oneHour: '1 heure',
      eightHours: '8 heures',
      oneDay: '24 heures',
      indefinitely: 'Indéfiniment',
      success: 'Notifications pour cette publication désactivées avec succès',
      error: 'Échec de la désactivation des notifications pour cette publication',
    },
    unmute: {
      success: 'Notifications pour cette publication reprises avec succès',
      error: 'Échec de la reprise des notifications pour cette publication',
    },
    getMutedState: {
      error: "Échec de l'obtention de l'état des notifications",
    },
    dismissAnnouncement: {
      success: 'Annonce masquée',
      error: "Échec du masquage de l'annonce",
    },
    delete: {
      confirmTitle: 'Supprimer la publication',
      confirmMessage:
        'Es-tu sûr de vouloir supprimer la publication ? Cette action ne peut pas être annulée.',
      success: 'Publication supprimée avec succès',
      error: 'Échec de la suppression de la publication',
    },
    share: {
      title: 'Partager la publication',
      message: 'Regardez cette publication de {{userName}}',
      success: 'Publication partagée avec succès',
      copied: 'Lien copié dans le presse-papiers',
      error: 'Impossible de partager la publication',
      shareLink: 'Partager le lien',
      copy: 'Copier',
      open: 'Ouvrir',
      postUrl: 'URL de la publication',
    },
  },
  media: {
    gif_button_label: 'Ajouter un GIF',
    no_results: 'Aucun GIF trouvé',
    failed_to_load: 'Impossible de charger le GIF',
    search_placeholder: 'Rechercher sur {{provider}}',
    powered_by: 'Propulsé par {{provider}}',
  },
  comments: {
    title: 'Commentaires',
    titleOnItem: 'Commentaires sur {{itemType}} de {{userName}}',
    empty: 'Soyez le premier à commenter !',
    add_placeholder: 'Ajouter un commentaire...',
    added: 'Ton commentaire a été publié',
    add_error: 'Échec de la publication du commentaire',
    editSuccess: 'Ton commentaire a été mis à jour',
    editError: 'Échec de la mise à jour du commentaire',
    menu: {
      edit: 'Modifier le commentaire',
      report: 'Signaler le commentaire',
      delete: 'Supprimer le commentaire',
    },
    delete: {
      confirmTitle: 'Supprimer le commentaire',
      confirmMessage:
        'Es-tu sûr de vouloir supprimer le commentaire ? Cette action ne peut pas être annulée.',
      success: 'Commentaire supprimé avec succès',
      error: 'Échec de la suppression du commentaire',
    },
    viewMore_one: 'Voir {{count}} autre commentaire',
    viewMore_other: 'Voir {{count}} autres commentaires',
  },
  likes: {
    title: "J'aimes",
    titleOnItem: "J'aimes sur {{itemType}} de {{userName}}",
  },
  notifications: {
    title: 'Notifications',
    titleNative: 'Notifications push',
    empty: 'Aucune notification pour le moment',
    newNotifications: 'Nouvelles notifications',
    clearAll: 'Tout effacer',
    clearAllConfirmTitle: 'Effacer les notifications',
    clearAllConfirmMessage:
      "Cela masquera toutes tes notifications, y compris les demandes d'accès à tes photos privées en attente. Continuer ?",
    clearAllSuccess: 'Notifications effacées',
    clearAllError: "Impossible d'effacer les notifications",
    dismiss: 'Masquer la notification',
    dismissSuccess: 'Notification masquée',
    dismissError: 'Impossible de masquer la notification',
    andOthers_one: '(et {{count}} autre)',
    andOthers_other: '(et {{count}} autres)',
    unlockAcceptSuccess: 'Demande de déverrouillage acceptée',
    unlockAcceptError: "Échec de l'acceptation de la demande de déverrouillage",
    unlockRejectSuccess: 'Demande de déverrouillage refusée',
    unlockRejectError: 'Échec du refus de la demande de déverrouillage',
    permissionDisabledTitle: 'Les notifications push sont désactivées',
    permissionDisabledDescription:
      'Active les notifications dans les réglages pour ne rien manquer.',
    openSettings: 'Ouvrir les réglages',
  },
  settings: {
    title: 'Paramètres',
    appearance: 'Apparence',
    location: {
      title: 'Localisation',
      current: 'Publié comme',
      mode: 'Nom du lieu',
      fixed: 'Fixe',
      automatic: 'Automatique',
      enable: 'Activer la localisation...',

      enableHelp: 'Activer la localisation',
      enableHelpBlocked: "Ton navigateur bloque actuellement l'acces a ta localisation",
      enableHelpSteps:
        "Pour l'activer, suis les etapes ci-dessous :\n\n\u2022 Ouvre le menu d'informations du site pres de la barre d'adresse (icone de cadenas, de parametres ou d'informations).\n\u2022 Trouve les autorisations pour ce site et localise le parametre de localisation.\n\u2022 Change la localisation sur Autoriser (ou Demander a chaque fois).\n\u2022 Recharge la page.",
      tips: 'Conseils et confidentialité',
      fixedSet: 'Emplacement publié mis à jour',
      fixedError: "Impossible de définir l'emplacement",
      searchPlaceholder: 'Ville, code postal ou adresse',
      searchHint: 'Tape au moins 2 caractères',
      noResults: "Aucun lieu correspondant. Vérifie l'orthographe ou essaie une ville proche.",
      searchError: 'Échec de la recherche de lieux',
      pickPlace: 'Choisir un lieu',
      autoDescription:
        'Le nom du lieu (ville) affiché sur ton profil sera mis à jour lorsque tu te déplaces',
    },
    account: {
      title: 'Compte',
      username: {
        title: "Changer le nom d'utilisateur",
        title_short: "Nom d'utilisateur",
        label: "Nouveau nom d'utilisateur",
        placeholder: "Entrez le nouveau nom d'utilisateur",
        helper:
          "Choisissez un nouveau nom d'utilisateur de 2 à 20 caractères commençant par une lettre. Seules les lettres, les chiffres, - et _ sont autorisés.",
        invalid: "Nom d'utilisateur invalide",
        unavailable: "Ce nom d'utilisateur est déjà pris",
        current: 'Utilisateur :',
        updateAndSignOut: 'Mettre à jour et se déconnecter',
        successSignOut:
          "Nom d'utilisateur mis à jour. Reconnecte-toi avec ton nouveau nom d'utilisateur.",
        error: "Échec de la mise à jour du nom d'utilisateur",
      },
      email: {
        title: 'Changer e-mail',
        title_short: 'E-mail',
        label: 'Nouvel e-mail',
        placeholder: 'Entrez le nouvel e-mail',
        changeExplanation:
          'Nous enverrons un lien de confirmation à ta nouvelle adresse. Ton e-mail sera mis à jour après confirmation.',
        invalid: 'Entrez une adresse e‑mail valide',
        unavailable: 'Cet e-mail est déjà utilisé',
        current: 'E-mail :',
        success: "Changement d'e-mail demandé. Vérifie ta boîte mail pour confirmer.",
        error: "Échec de la mise à jour de l'e-mail",
      },
      password: {
        title: 'Changer le mot de passe',
        change: 'Changer le mot de passe',
        old: 'Mot de passe actuel',
        new: 'Nouveau mot de passe (min. 6 caractères)',
        repeat: 'Répétez le nouveau mot de passe',
        mismatch: 'Les mots de passe ne correspondent pas',
        oldRequired: 'Entre ton mot de passe actuel',
        success: 'Mot de passe mis à jour',
        error: 'Échec de la mise à jour du mot de passe',
      },
      delete: {
        title: 'Supprimer le compte',
        confirmLabel: 'Confirme avec ton mot de passe actuel',
        confirmMessage: 'Cette action est définitive. Entre ton mot de passe pour confirmer.',
        placeholder: 'Entrez le mot de passe actuel',
        submit: 'Supprimer mon compte',
        required: 'Entre ton mot de passe actuel',
        success: 'Ton compte a été supprimé',
        error: 'Échec de la suppression du compte',
      },
    },
    privacy: {
      title: 'Confidentialité et Sécurité',
      blockedMembers: 'Membres bloqués',
      photoUnlockAuthorized: 'Autorisations photos privées',
      emptyHelp: {
        blocked:
          'Les membres que tu bloques apparaîtront ici. Tu peux retirer un blocage à tout moment.',
        photoUnlockAuthorized:
          "Les membres à qui tu as autorisé l'accès à tes photos privées apparaîtront ici. Tu peux révoquer l'accès à tout moment.",
      },
      removeUnlock: {
        title: "Retirer l'accès",
        action: "Retirer l'accès",
        confirmMessage: "Retirer l'accès à tes photos privées pour {{userName}} ?",
        success: 'Accès retiré',
        error: "Échec du retrait de l'accès",
      },
    },
    language: 'Langue',
    system: 'Identique au système',
    community: 'Communauté',
    pattern: "Motif d'en-tête",
    patterns: {
      none: 'Aucun',
      bones: 'Os et pattes',
      circles: 'Cercles',
      food: 'Nourriture',

      japanese: 'Japonais',
      plaid: 'Carreaux',
      polygonal: 'Polygonal',
      sprinkles: 'Paillettes',
      stars: 'Étoiles',
      triangles: 'Triangles',
    },
    appIcon: {
      title: "Icone de l'app",
      description: "Choisis l'icone qui apparait sur ton ecran d'accueil.",
      changed: "Icone de l'app mise a jour",
    },
    theme: {
      title: 'Thème',
      auto: 'Identique au système',
      light: 'Mode clair',
      dark: 'Mode sombre',
    },
    units: {
      title: 'Unités',
      distance: 'Distance',
      distanceKm: 'Kilomètres (km)',
      distanceMi: 'Miles (mi)',
      height: 'Taille',
      heightM: 'Mètres (m)',
      heightFt: 'Pieds (ft)',
      weightUnit: 'Poids',
    },
    diagnostics: {
      title: 'Outils de diagnostic',
      signalr: 'Diagnostics SignalR',
      clearCache: 'Vider le cache',
      cacheCleared: 'Cache vidé avec succès',
    },
    preferences: {
      title: 'Préférences',
      birthdayList: "Liste d'anniversaires",
      birthdayListDescription: "M'afficher dans la liste d'anniversaires",
      anonymousViewing: 'Navigation anonyme',
      anonymousViewingDescription:
        'Parcourir les profils sans apparaître dans la liste des visiteurs',
      inboundMessagePhotos: 'Photos entrantes',
      inboundMessagePhotosDescription:
        "Autoriser les photos dans les DMs de n'importe qui (sinon uniquement des personnes que tu suis)",
      emailNotifications: 'Notifications par e-mail',
      emailNotificationsDescription: 'Recevoir des e-mails pour les nouveaux messages',
      photosInNewsfeed: "Photos dans le fil d'actualité",
      photosInNewsfeedDescription: 'Afficher les publications avec photos dans le fil global',
      mediaInComments: 'Afficher les GIFs dans les commentaires',
      mediaInCommentsDescription:
        'Affiche les GIFs et autres médias dans les commentaires des publications et photos.',
      safeModeOff: 'Médias sensibles et non révisés',
      safeModeOffDescription: 'Afficher les médias pouvant contenir du contenu sensible (NSFW)',
    },
    safety: {
      title: 'Options de sécurité',
    },
    notifications: {
      title: 'Notifications',
      titleWithSounds: 'Notifications et sons',
      description: 'Choisissez les activités qui déclenchent des notifications push',
      futureNotifications:
        'Les notifications push suivantes sont prévues pour une mise en œuvre future et ne sont pas actuellement actives.',
      newMessage: 'Nouveaux messages',
      newMessageDescription: "Quand quelqu'un t'envoie un message",
      newFollower: 'Nouveaux abonnés',
      newFollowerDescription: "Quand quelqu'un te suit",
      newPhotoComment: 'Commentaires de photos',
      newPhotoCommentDescription: "Quand quelqu'un commente tes photos",
      newPostComment: 'Commentaires de publications',
      newPostCommentDescription: "Quand quelqu'un commente tes publications",
      newWallPost: 'Publications sur le mur',
      newWallPostDescription: "Quand quelqu'un publie sur ton mur",
      web: {
        mobileTitle: 'Les notifications push ne sont pas disponibles sur le web',
        mobileSubtitle:
          "Installe l'app iOS ou Android pour recevoir des notifications push quand quelqu'un t'écrit ou interagit avec ton contenu.",
        soundsDescription:
          "Choisis un son à jouer quand un nouvel événement arrive. Les sons sont joués par ton navigateur, garde donc l'onglet {{communityName}} ouvert.",
        messageSoundLabel: 'Son de nouveau message',
        notificationSoundLabel: 'Son de nouvelle notification',
        preview: 'Écouter le son',
        appStoreButton: "Télécharger sur l'App Store",
        googlePlayButton: 'Disponible sur Google Play',
      },
      sounds: {
        off: 'Désactivé',
        trill: 'Trille',
        stepUp: 'Montée',
        bubblePop: 'Pop de bulle',
        marimba: 'Marimba',
        metro: 'Métro',
        retro: 'Rétro',
        sparkle: 'Scintillement',
        strings: 'Cordes',
      },
    },
    dangerZone: 'Zone de danger',
    about: {
      title: 'À propos de cette appli',
      version: 'Version',
      build: 'build',
      madeWithCities: 'Fait avec ❤️ à Montréal, New York et San Francisco',
      whatsNew: 'Nouveautés de cette version',
    },
  },
  whatsNew: {
    title: 'Nouveautés',
    currentReleaseTitle: 'Dans cette version',
    catchUpReleaseTitle: 'Depuis la derniere mise a jour',
    recentUpdatesTitle: 'Mises a jour recentes',
    lineageLabel: 'Version {{lineage}}',
    empty: 'Aucune nouveauté à afficher.',
    neverShowAgain: 'Ne plus afficher',
    showOnNewVersions: 'Afficher cette fenêtre pour les nouvelles versions',
  },
  upgrade: {
    prompt: 'Obtiens des photos pleine grandeur dans ton fil sans limite quotidienne',
    upgrade_button: 'Obtenir premium',
  },
  premium: {
    upgradeCard: {
      photos: '...et bien plus encore ! Passez à {{premiumPlan}} pour voir toutes les photos.',
      members: '...et bien plus encore ! Passez à {{premiumPlan}} pour voir tous les membres.',
      conversation: 'Passe à {{premiumPlan}} pour accéder à tout ton historique de conversations.',
    },
  },
  paywall: {
    ViewFullsizePhoto:
      'Limite actuelle atteinte pour voir les photos pleine grandeur. Passez à {{premiumPlanName}} pour un accès illimité.',
    OutgoingCommunication:
      'Limite actuelle atteinte pour envoyer des messages et publications. Passez à {{premiumPlanName}} pour une communication illimitée.',
    NewsfeedSearch:
      'Limite actuelle atteinte pour les recherches dans le fil. Passez à {{premiumPlanName}} pour des recherches illimitées.',
    ValidateGiftCertificate:
      'Limite actuelle atteinte pour les validations de certificats-cadeaux.',
    Blocks:
      'Tu as atteint le nombre maximum de membres bloqués. Passe à {{premiumPlanName}} pour plus de blocages.',
    BlockingAMember:
      'Tu as récemment bloqué ou débloqué ce membre. Attends 3 jours avant de le bloquer ou débloquer à nouveau.',
    PostsPerHour:
      'Tu as atteint ta limite de publications par heure. Attends avant de publier à nouveau.',
    ChangeOfEmail:
      "Limite actuelle atteinte pour les demandes de changement d'email. Veuillez réessayer demain.",
    PhotoStream:
      'Limite actuelle atteinte pour voir les flux de photos. Passez à {{premiumPlanName}} pour un accès illimité.',
    FeaturedPhotos:
      "Tu ne peux mettre en vedette qu'une seule photo dans le fil global par heure. Attends avant d'en publier une autre.",
    PhotoUnlockRequests:
      'Limite actuelle atteinte pour les demandes de déverrouillage de photos. Passez à {{premiumPlanName}} pour des demandes illimitées.',
    AnonymousViewing:
      'La navigation anonyme nécessite un abonnement {{premiumPlanName}}. Passez à {{premiumPlanName}} pour parcourir les profils sans apparaître dans les listes de visiteurs.',
    PostsPerDay: 'Tu as atteint ta limite de publications quotidiennes. Réessaie demain.',
    UploadedPhotos:
      'Tu as atteint ta limite de photos. Passe à {{premiumPlanName}} pour télécharger plus de photos.',
    UploadedPhotosPerDay:
      "Tu as atteint ta limite quotidienne de téléchargement de photos. Passe à {{premiumPlanName}} pour télécharger plus de photos aujourd'hui.",
    MemberSearch:
      'Tu as atteint la limite quotidienne de recherches. Passe à {{premiumPlanName}} pour des recherches illimitées.',
    MyTypeFilterChange:
      'Tu as atteint la limite quotidienne pour modifier ton filtre de type. Passe à {{premiumPlanName}} pour le modifier quand tu veux.',
    default:
      'Cette fonctionnalité nécessite un compte {{premiumPlanName}}. Passez à {{premiumPlanName}} pour continuer.',
    resetIn: {
      minutes_one: 'Réessayer dans {{count}} minute',
      minutes_other: 'Réessayer dans {{count}} minutes',
      hours_one: 'Réessayer dans {{count}} heure',
      hours_other: 'Réessayer dans {{count}} heures',
    },
  },
  notFound: {
    title: 'Désolé, nous ne trouvons pas ce que tu cherches.',
    goHome: "Retour à l'écran d'accueil",
  },
  communitiesHeader: {
    title: 'Communautés',
  },
  profile: {
    aboutMe: 'À propos de moi',
    stats: 'Statistiques',
    bio: 'Biographie',
    height: 'Taille',
    weight: 'Poids',
    gender: 'Genre',
    origin: 'Origine',
    relationship: 'Relation',
    languages: 'Langues',
    interestedIn: 'Intéressé par',
    preferences: 'Préférences',
    lookingFor: 'Recherche',
    bodyTypesLiked: 'Types de corps',
    bodyPartsLiked: 'Caractéristiques corporelles',
    sexualInterests: 'Intérêts sexuels',
    mutualKinks: 'Fétiches mutuels',
    // Shared field labels (used by search, profile view, and edit profile)
    identifyAs: "S'identifie comme",
    relationshipStatus: 'Statut relationnel',
    bodyTypes: 'Types de corps',
    bodyHair: 'Pilosité corporelle',
    facialHair: 'Pilosité faciale',
    communityKinks: 'Fétiches de la communauté',
    otherKinks: 'Autres fétiches',
    // Section titles
    sections: {
      identity: 'Identité et origine',
      interestsAndKinks: 'Intérêts et kinks',
      bodyFeatures: 'Types de corps et caractéristiques',
    },
    // Units
    units: {
      weight: {
        pounds: 'Livres (lb)',
        kilograms: 'Kilogrammes (kg)',
        stones: 'Stones (st)',
        short: {
          lb: 'lb',
          kg: 'kg',
          st: 'st',
        },
        suffix: {
          lbs: 'lbs',
          kg: 'kg',
          st: 'st',
        },
      },
      height: {
        feet: 'Pieds (ft)',
        meters: 'Mètres (m)',
        short: {
          ft: 'ft',
          m: 'm',
        },
        suffix: {
          m: 'm',
        },
      },
    },
    lastSeen: 'Dernière connexion',
    lastVisitedYou: 'A vu ton profil',
    notYet: 'Pas encore',
    activity: 'Activité',
    joinDateWithCommunity: 'Sur {{communityName}} depuis',
    seeAllPhotos: 'Voir tout',
    followers: 'abonnés',
    followers_one: 'abonné',
    followers_other: 'abonnés',
    following: 'abonnements',
    following_one: 'abonnement',
    following_other: 'abonnements',
    follows_you: 'Te suit',
    followersCount_one: '{{count}} abonné',
    followersCount_other: '{{count}} abonnés',
    followingCount: '{{count}} abonnements',
    followersOfUser: 'Abonnés à {{userName}}',
    followingOfUser: 'Abonnements de {{userName}}',
    tabs: {
      about: 'À propos',
      posts: 'Publications',
      photos: 'Photos',
      events: 'Événements',
      weight: 'Poids',
      wall: 'Mur',
    },
    photos: {
      public: 'Publiques',
      private: 'Privées',
      privateLocked: 'Les photos privées sont verrouillées',
      requestAccess: "Demander l'accès",
      extendedPreviewNotice: 'Tu vois plus de photos parce que ce membre est abonné à {{premiumPlan}}.',
      requestPending: "Ta demande d'accès aux photos privées est en attente d'approbation",
      requestSubmitted: "Demande d'accès envoyée",
      requestFailed: "Échec de l'envoi de la demande d'accès",
    },
    wall: {
      empty: 'Aucune publication à afficher',
    },
    share: {
      title: 'Partager le profil',
      message: 'Découvrez le profil de {{userName}}',
      shareProfile: 'Partager le profil',
    },
  },
  member: {
    notFound: 'Membre introuvable',
    menu: {
      report: 'Signaler le membre',
      block: 'Bloquer le membre',
      unblock: 'Débloquer le membre',
      privatePhotosSection: 'Photos privées',
      revokePrivatePhotos: {
        action: "Révoquer l'accès",
        confirmTitle: "Révoquer l'accès",
        confirmMessage:
          '{{userName}} ne pourra plus voir tes photos privées. Cette personne pourra te renvoyer une demande plus tard.',
        success: 'Accès révoqué',
        error: "Échec de la révocation de l'accès",
      },
      forfeitPrivatePhotos: {
        action: 'Se désabonner',
        confirmTitle: 'Se désabonner',
        confirmMessage:
          "Tu ne verras plus les photos privées de {{userName}}. Tu pourras redemander l'accès plus tard.",
        success: 'Désabonné',
        error: 'Échec du désabonnement',
      },
    },
    block: {
      confirmMessage:
        'Es-tu sûr de vouloir bloquer {{userName}} ? Cette action ne peut pas être annulée pendant les 72 prochaines heures pour prévenir le harcèlement.',
      success: 'Membre bloqué avec succès',
      error: 'Échec du blocage du membre',
    },
    unblock: {
      confirmMessage:
        'Es-tu sûr de vouloir débloquer {{userName}} ? Cette action ne peut pas être annulée pendant les 72 prochaines heures pour prévenir le harcèlement.',
      success: 'Membre débloqué avec succès',
      error: 'Échec du déblocage du membre',
    },
    unfollow: {
      confirmTitle: 'Ne plus suivre',
      confirmMessage: 'Es-tu sûr de ne plus vouloir suivre {{userName}} ?',
      success: 'Tu ne suis plus {{userName}}',
      error: 'Échec pour arrêter de suivre le membre',
    },
    follow: {
      success: 'Tu suis maintenant {{userName}}',
      error: 'Échec pour suivre le membre',
    },
    locked: {
      message: 'Passez à {{premiumPlan}} pour parcourir un nombre illimité de profils de membres.',
    },
  },
  userMenu: {
    viewProfile: 'Voir mon profil',
    editProfile: 'Modifier mon profil',
    settings: 'Paramètres',
    plans: 'Forfaits et abonnement',
    help: 'Aide et support',
    feedback: 'Feedback',
    rules: 'Règles de la communauté',
    browseCommunities: 'Parcourir les communautés',
    signOut: 'Se déconnecter',
  },
  editProfile: {
    title: 'Modifier le profil',
    saveSuccess: 'Profil mis à jour avec succès',
    saveError: 'Échec de la mise à jour du profil',
    loadError: 'Échec du chargement du profil',
    saving: 'Enregistrement...',
    sections: {
      basicInfo: 'Informations de base',
    },
    firstName: 'Prénom',
    firstNamePlaceholder: 'Entre ton prénom',
    birthDate: 'Date de naissance',
    selectYear: "Sélectionner l'année",
    selectMonth: 'Sélectionner le mois',
    selectDay: 'Sélectionner le jour',
    selectHeight: 'Sélectionner la taille',
    weightGoal: 'Objectif de poids',
    weightRangeError: 'Le poids doit être dans la plage autorisée',
    descriptionPlaceholder: 'Parle-nous de toi...',
    textPlaceholder: 'Entrez du texte...',
    notSet: 'Non défini',
    identifyAs: "Je m'identifie comme",
    myBodyType: 'Mon type de corps',
    bodyTypesLiked: "Types de corps que j'aime",
    bodyPartsLiked: "Caractéristiques physiques que j'aime",
    myBodyHair: 'Ma pilosité corporelle',
    myFacialHair: 'Ma pilosité faciale',
    hints: {
      firstName: "Optionnel. Apparaît sur ton profil après ton nom d'utilisateur.",
      birthDate:
        'Non visible par les autres utilisateurs. Utilisé pour vérifier que tu es majeur et afficher ton âge.',
      bio: 'Parle de toi, de ce que tu aimes et de ce que tu recherches.',
    },
  },
  account: {
    plans: {
      title: 'Forfaits et abonnement',
      includedWith: 'Ce qui est inclus avec {{planName}}',
      choosePlan: 'Choisis ton forfait',
      terms: 'Conditions',
      bestValue: 'MEILLEURE VALEUR',
      monthlyPlan: 'Forfait mensuel {{planName}}',
      yearlyPlan: 'Forfait annuel {{planName}}',
      regularPrice: 'Prix régulier',
      perMonth: 'par mois',
      perYear: 'par an',
      onlyPerMonth: 'Seulement {{price}}/mois (économisez {{percent}}%)',
      pricesIn: 'Prix en {{currency}}.',
      billingTerms_ios:
        "Le paiement sera débité de ton compte Apple à la confirmation de l'achat. Les forfaits sont valables pour la durée que tu sélectionnes et se renouvelleront automatiquement au prix indiqué sauf annulation au moins 24 heures avant la fin de la période en cours. Tu peux annuler ton abonnement à tout moment dans les paramètres de ton appareil ou en utilisant Gérer l'abonnement ci-dessus.",
      billingTerms_android:
        "Le paiement sera débité de ton compte Google à la confirmation de l'achat. Les forfaits sont valables pour la durée que tu sélectionnes et se renouvelleront automatiquement au prix indiqué sauf annulation au moins 24 heures avant la fin de la période en cours. Tu peux annuler ton abonnement à tout moment dans les paramètres de ton appareil ou en utilisant Gérer l'abonnement ci-dessus.",
      billingTerms_web:
        "Les conditions d'abonnement et les détails de facturation seront fournis lors du paiement. Ton abonnement se renouvellera automatiquement sauf annulation avant la date de renouvellement.",
      privacyPolicy: 'Politique de confidentialité',
      termsOfUse: "Conditions d'utilisation",
      manageSubscription: 'Gérer les abonnements',
      currentPlan: 'Forfait actuel',
      loading: 'Chargement des forfaits...',
      confirming: 'Confirmation de ton abonnement...',
      connecting: 'Connexion au magasin...',
      connectionError: 'Erreur de Connexion',
      openPlayStore: 'Ouvrir Play Store',
      signInToPlayStore: 'Connecte-toi à Google Play Store pour continuer',
      openAppStore: 'Ouvrir App Store',
      checkAppStoreConnection: "Vérifie ta connexion à l'App Store et réessaie",
      premiumFeatures: {
        unlimitedPhotos: 'Visualisation illimitée de photos',
        featureMorePhotosToRegularMembers: 'Montre plus de tes photos aux membres non abonnés',
        unlimitedMessaging: 'Messagerie illimitée',
        moreBlocks: 'Plus de blocages',
        morePhotoUploads: 'Plus de téléchargements de photos',
      },
      learnMoreAboutPlans: 'Tout savoir sur nos plans',
      yourAccountIsOn: 'Ton compte est sur le plan {{planName}}',
      currentCreditsUntil: "Crédits actuels valables jusqu'au :",
      daysLeft_one: '{{count}} jour restant',
      daysLeft_other: '{{count}} jours restants',
      hoursLeft_one: '{{count}} heure restante',
      hoursLeft_other: '{{count}} heures restantes',
      subscriptionRenewalNote:
        "Ton abonnement se renouvelle automatiquement selon ton cycle de facturation. Chaque renouvellement ajoute des crédits à ton compte. Les crédits provenant de promotions ou de certificats-cadeaux peuvent s'étendre au-delà de ta période d'abonnement actuelle. Merci d'être membre {{planName}} !",
      billingNotAvailable: 'Les abonnements ne sont actuellement pas disponibles',
      grandfatheredPricing: 'Félicitations ! Tu bénéficies de nos anciens prix réduits.',
      oneMonth: 'Mensuel',
      threeMonths: 'Trimestriel',
      oneYear: 'Annuel',
      oneYearCombo: 'Annuel Duo',
      comboSubtitle: 'Comprend Grommr XL et 1 an de Chasable+ (certificat cadeau)',
      every3Months: 'tous les 3 mois',
      save: 'économisez {{percent}}%',
      renewsEveryDays: 'Se renouvelle automatiquement tous les {{days}} jours',
      subscribe: "M'abonner",
      subscribed: 'Abonné',
      manageCCBill: 'Annuler/gérer un abonnement CCBill',
      subscriptionIdLabel: "Ton ID d'abonnement CCBill le plus récent",
      subscriptionIdCopied: "ID d'abonnement copié dans le presse-papiers",
      ccbillPayments: 'Paiements CCBill (Abonnements)',
      ccbillDescription:
        "Nous utilisons CCBill pour gérer notre facturation et il existe plusieurs façons d'acheter ton pass par carte de crédit : Nous acceptons Visa, Mastercard, JCP et Discover. Ton relevé de carte de crédit affichera \"CCBill.Com *Grokio\" (Grokio Communities LLC est la société d'exploitation derrière {{communityName}}). Tu as la possibilité d'effectuer ta transaction dans l'une des cinq devises : USD ; EUR ; GBP ; CAD ; AUD ; et JPY. Dès que nous recevrons la confirmation du paiement, le nouveau temps sera ajouté à ton compte (dans la plupart des cas, cela devrait être immédiat). Tous les abonnements via CCBill se renouvellent automatiquement. Si tu souhaites annuler ton abonnement, tu peux utiliser le lien fourni et l'annuler au moins 48 heures avant son renouvellement.",
      billingFaq: 'Informations de facturation et FAQ',
      billingFaqDescription:
        "Consultez notre document d'informations de facturation {{planName}} pour plus de détails sur les paiements, les renouvellements et les annulations.",
      billingFaqGuide: 'Guide de {{planName}}',
      getBillingSupport: 'Obtenir une assistance pour la facturation',
      restorePurchases: 'Restaurer les achats',
      error: {
        loadProducts: "Échec du chargement des forfaits d'abonnement",
        noProductsFound: "Aucun produit d'abonnement trouvé",
        purchase: 'Achat échoué',
        purchasePayment:
          "Ton achat n'a pas pu être finalisé. Vérifie ton moyen de paiement et réessaie.",
        purchaseNetwork:
          'Impossible de se connecter au magasin. Vérifie ta connexion internet et réessaie.',
        purchaseUnavailable:
          'Les achats intégrés ne sont pas disponibles sur cet appareil ou ce compte.',
        purchaseAlreadyOwned: 'Tu as déjà un abonnement actif pour ce forfait.',
        purchaseDeferred:
          "Ton paiement est en attente d'approbation. L'abonnement sera activé une fois approuvé.",
        purchaseItemUnavailable: "Ce forfait d'abonnement n'est pas disponible actuellement.",
        validation: "Échec de la validation de l'achat",
        restore: 'Échec de la restauration — réessaie ou contacte le support',
        restoreUnavailable:
          'Impossible de joindre le magasin. Vérifie ta connexion et réessaie.',
      },
      success: {
        subscribedWithPlan:
          "Merci de t'être abonné ! Ton abonnement {{planName}} est maintenant actif.",
        subscribedWithBogo:
          "Merci de t'être abonné ! Ton {{planName}} est maintenant actif. Bonus : Tu as gagné un {{period}} supplémentaire avec notre promotion !",
        restored: 'Achats restaurés avec succès',
        nothingToRestore: 'Aucun achat à restaurer',
      },
    },
    transactions: {
      title: 'Historique des transactions',
      empty: 'Aucune transaction pour le moment',
      days_one: 'jour',
      days_other: 'jours',
      header: {
        date: 'Date',
        description: 'Description',
      },
    },
    certificates: {
      title: 'Certificats Cadeaux',
      history: 'Tes certificats cadeaux',
      empty: 'Aucun certificat cadeau pour le moment',
      purchase: 'Achat de Certificat Cadeau',
      redeemed: 'Certificat Cadeau Utilisé',
      redeemedOn: 'Utilisé le {{date}}',
      codeCopied: 'Code du certificat copié dans le presse-papiers',
      redeem: {
        title: 'Utiliser un certificat cadeau',
        helper: 'Entre le code que tu as reçu pour ajouter du temps premium à ton compte.',
        placeholder: 'XXXXX-XXXXX-XXXXX-XXXXX-XXXXX',
        button: 'Utiliser',
        success_one: 'Certificat cadeau utilisé ! {{count}} jour a été ajouté à ton compte.',
        success_other: 'Certificat cadeau utilisé ! {{count}} jours ont été ajoutés à ton compte.',
        invalidFormat: 'Ceci ne ressemble pas à un code de certificat cadeau. Les codes comptent 25 lettres et chiffres.',
        notFound: "Nous n'avons pas trouvé ce code. Assure-toi de l'utiliser dans la communauté pour laquelle il a été émis.",
        alreadyRedeemed: 'Ce certificat cadeau a déjà été utilisé.',
        tooManyAttempts: 'Trop de tentatives. Réessaie demain.',
        error: "Nous n'avons pas pu utiliser ce certificat cadeau. Réessaie plus tard.",
      },
      header: {
        date: 'Date',
        details: 'Détails',
      },
    },
  },
  webDrop: {
    dropToUpload: 'Déposez une image pour téléverser',
    dragHint: 'Glissez une image JPG/PNG ici',
  },
  weightHistory: {
    stats: 'Statistiques',
    currentWeight: 'Actuel',
    trend: 'Tendance',
    bmi: 'IMC',
    goal: 'Objectif',
    perMonth: '/mois',
    history: 'Historique',
    date: 'Date',
    weight: 'Poids',
    notes: 'Notes',
    noData: 'Aucun enregistrement de poids pour le moment',
    noChartData: 'Pas assez de données pour le graphique',
    addRecord: 'Ajouter',
    editRecord: 'Modifier le poids',
    selectDate: 'Sélectionner une date',
    notesPlaceholder: 'Notes facultatives...',
    added: 'Poids ajouté',
    updated: 'Poids mis à jour',
    deleted: 'Enregistrement de poids supprimé',
    saveFailed: 'Échec de la sauvegarde',
    deleteFailed: "Échec de la suppression de l'enregistrement",
    deleteTitle: 'Supprimer',
    deleteConfirm: 'Supprimer cet enregistrement de poids ?',
  },
  footer: {
    support: 'Assistance',
    terms: "Conditions d'utilisation",
    privacy: 'Politique de confidentialité',
  },
  report: {
    reasonTitle: 'Pourquoi signales-tu ceci ?',
    rulesLink: 'Lis les Règles de la communauté',
    reasons: {
      scam: 'Arnaqueur',
      spam: 'Spam',
      falsePortrayal: 'Fausse identité',
      harassment: 'Harcèlement',
      intolerance: 'Intolérance',
      trolling: 'Trolling',
      disparagement: 'Dénigrement',
      donationRequest: 'Demande de dons',
      promotionalPosting: 'Publication promotionnelle non conforme',
      photoPolicy: 'Violation de la politique photo',
      uncreditedArtwork: 'Œuvre non créditée',
      underage: 'Mineur',
      illegalActivity: 'Autres activités illégales',
      other: 'Autre',
    },
  },
};
